/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Quota_Weekly_OneInputs */

const fr_membership_quota_weekly_one = /** @type {(inputs: Membership_Quota_Weekly_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 séance / semaine`)
};

/**

* @param {Membership_Quota_Weekly_OneInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_quota_weekly_one = /** @type {((inputs?: Membership_Quota_Weekly_OneInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Quota_Weekly_OneInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_quota_weekly_one(inputs)
});